module.exports = __webpack_public_path__ + "media/images/dryer-6262eeac16af896074307014b04b842e.png";